import * as React from "react";

import { Badge } from "@/components/ui/badge";
import { TRAFFIC_LIGHT_VARIANT, TrafficLightRating } from "@/modules/snapshots/businessReports.types";

interface Props {
  rating: TrafficLightRating;
}

export const TrafficLightCell: React.FC<Props> = ({ rating }) => (
  <div className="flex min-w-0 flex-1 items-center justify-center">
    <Badge variant={TRAFFIC_LIGHT_VARIANT[rating]} className="flex-shrink-0">
      {rating}
    </Badge>
  </div>
);
